import { motion } from 'framer-motion';

interface AtmosphereSectionProps {
  onRegisterClick: () => void;
}

export default function AtmosphereSection({ onRegisterClick }: AtmosphereSectionProps) {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'Открытые дискуссии вместо моно-лекций',
      description: 'Живой обмен мнениями и опытом между коллегами'
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: 'Неформальный контакт с экспертами',
      description: 'Возможность задать вопросы в комфортной обстановке'
    },
    {
      icon: 'ri-emotion-happy-line',
      title: 'Наука × культура',
      description: 'Мини-спектакли от театра «Монплезир»'
    },
    {
      icon: 'ri-team-line',
      title: 'Камерность',
      description: 'Небольшой зал, личный контакт с каждым участником'
    }
  ];

  return (
    <section className="py-24 px-6 bg-[#F8F7F4] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#D8B36A] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#101A2E] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#101A2E] mb-4 text-center" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Атмосфера «Петербуржских вечеров»
          </h2>
          
          <p className="text-xl text-[#1E2430] text-center mb-12 font-medium">
            Профессионально, но неформально
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white/60 backdrop-blur-xl rounded-2xl p-8 border border-white/40 hover:bg-white/80 transition-all duration-300 hover:shadow-xl"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#D8B36A] to-[#C9A459] rounded-2xl mb-5 shadow-lg">
                  <i className={`${feature.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#101A2E] mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
                  {feature.title}
                </h3>
                <p className="text-base text-[#1E2430]/80 leading-relaxed text-justify">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>

          <div className="text-center">
            <button
              onClick={onRegisterClick}
              className="px-8 py-4 bg-[#D8B36A] text-[#101A2E] rounded-lg font-bold text-base hover:bg-[#C9A459] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Присоединиться → Регистрация
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}